import {
  FRIENDLY_CONNECTIVITY_MESSAGE,
  isConnectivityErrorMessage,
  isConnectivityFailure,
} from '@buxus/shared'

function looksTechnical(message: string): boolean {
  const lower = message.toLowerCase()
  return (
    lower.includes('cors') ||
    isConnectivityErrorMessage(message) ||
    lower.startsWith('request failed (') ||
    lower.includes('an internal error occurred') ||
    lower.includes('remote service error') ||
    /\b[45]\d{2}\b/.test(message)
  )
}

/** User-facing copy for Send Alert preview/send failures — not for Bugsnag. */
export function friendlySendAlertError(err: unknown, _phase: 'preview' | 'send'): string {
  if (isConnectivityFailure(err) || (err instanceof Error && isConnectivityErrorMessage(err.message))) {
    return FRIENDLY_CONNECTIVITY_MESSAGE
  }

  if (err instanceof Error) {
    const msg = err.message.trim()
    if (msg && msg.length < 180 && !looksTechnical(msg)) {
      return msg.toLowerCase().includes('try again') ? msg : `${msg} Please try again.`
    }
  }

  return _phase === 'preview'
    ? "The preview couldn't be loaded. Please try again."
    : "The alert couldn't be sent. Please try again."
}
